module.exports = __webpack_public_path__ + "static/media/logo.7d5db3cd.png";